export const resetStore = () => ({ type: 'RESET_STORE' });
